const confid = {
    defaultTheme: 'light'
}

export default confid;